// Insert a Cloudinary transformation into an image URL. Non-Cloudinary URLs are returned as is.
export const withTransform = (url, transform) =>
    url && url.includes('/image/upload/') ? url.replace('/image/upload/', `/image/upload/${transform}/`) : url;

export const isVideo = (url) => url.includes('/video/upload/');

// Gallery photos display at most 500px wide; 1000px keeps them sharp on high-density screens.
// The originals are full camera size (up to 6 MB); this serves about a tenth of that.
// f_auto also converts HEIC uploads to a format every browser can show.
export const galleryImageUrl = (url) => withTransform(url, 'c_limit,w_1000,q_auto,f_auto');
